<template>
  <div class="select-node">
    <div class="select-tree">
      <div class="title"><span>控件</span></div>
      <el-input class="search" prefix-icon="el-icon-search" v-model="filterText"></el-input>
      <el-tree
        :data="treeData"
        show-checkbox
        node-key="id"
        ref="tree"
        :filter-node-method="filterNode"
        :check-strictly="true"
        :check-on-click-node="true"
        :default-expand-all="true"
        :props="defaultProps"
        @check-change="checkChange">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span><i :class="node.icon"></i>{{ data.name }}</span>
        </span>
      </el-tree>
    </div>
    <div class="selectedList">
      <div class="title"><span>已选择控件</span></div>
      <div class="person">
         <p v-for="selected in selectedList" :key="selected.id">
          <el-radio v-model="radio" :label="selected.id">
            {{selected[defaultProps.label]}}
          </el-radio>
        </p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'SelectNode',
  props: ['treeData', 'select', 'defaultAttr', 'single', 'disableType'],
  data () {
    return {
      defaultCheckedKeys: [],
      selectedList: [],
      radio: '',
      defaultProps: this.defaultAttr || {children: 'children', label: 'name'},
      filterText: ''
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    },
    'select' (val) {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      let defaultCheckedKeys = []
      if (this.select) {
        this.select.forEach(m => {
          defaultCheckedKeys.push(m.targetId)
        })
        let defaultValue = this.select.find(m => m.defaultValue === true)
        if (defaultValue) {
          this.radio = defaultValue.targetId
        }
        this.filterText = ''
      }
      this.$refs.tree.setCheckedKeys([])
      this.$refs.tree.setCheckedKeys(defaultCheckedKeys)
    },
    filterNode (value, data) {
      if (!value) return true
      if (data[this.defaultProps.label]) {
        return data[this.defaultProps.label].indexOf(value) !== -1
      }
    },
    checkChange (node, state) {
      // 选择节点内的控件父节点节点不可选择
      if (node.componentType === 'rc-form') {
        return false
      } else {
        let index = this.selectedList.findIndex(m => m.id === node.id)
        if (state) {
          if (this.single) {
            this.$refs.tree.setCheckedKeys([])
            this.$refs.tree.setCheckedKeys([`${node.id}`])
          }
          this.selectedList.push({'id': node.id, 'name': node.name, 'type': 'component'})
        } else {
          if (this.radio === node.id) {
            this.radio = ''
          }
          if (index > -1) {
            this.selectedList.splice(index, 1)
          }
        }
      }
    },
    getSelectedList () {
      return this.selectedList
    },
    getDefault () {
      return this.radio
    }
  }

}
</script>
<style lang="scss">
  .select-node {
    white-space: nowrap;
    width: 524px;
    margin: 0 auto;
    overflow: hidden;
    > div {
      border: 1px solid #C2C3C4;
      border-radius: 4px;
      width: 232px;
      height: 279px;
      float: left;
      text-align: center;
      .title {
        width: 100%;
        height: 24px;
        background-color: #EDEEEE;
        padding-top: 3px;
        span {
          font-size: 12px;
        }
      }
    }
    .select-tree {
      .el-tree {
        height: 215px;
        overflow: auto;
           > .el-tree-node >div:nth-child(1) .el-checkbox{
             display: none;
            }
      }
      .search {
        padding: 10px 10px 0 10px;
        .el-input__prefix {
          left: 10px;
          top: 5px;
        }
      }
      .el-tree-node__content {
        .custom-tree-node {
          font-size: 12px;
          .fa {
            padding-right: 5px;
          }
        }
      }
    }
    .selectedList {
      margin-left: 59px;
      float: left;
      .person {
        overflow: auto;
        height: 253px;
        > p {
          text-align: left;
          &.multiple-select {
            padding-left: 10px;
          }
          label {
            padding-left: 24px;
            padding-top: 10px;
            .el-radio__label {
              font-size: 12px;
            }
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/system/select-node.vue